"use client";

import { createContext, use } from "react";
import { COPY, type Copy } from "./copy";

/** The chat's own wording in its language (copy.ts). English outside a chat. */
export const CopyContext = createContext<Copy>(COPY.en);

export function useCopy(): Copy {
	return use(CopyContext);
}
